import React, { useState } from "react";
import { TiArrowSortedDown } from "react-icons/ti";
import { Link, useNavigate } from "react-router-dom";
import LeftSideFilterListItem from "./LeftSideFilterListItem";

import FilterBurgerMenu from "./FilterBurgerMenu";
import { delayNavigation } from "../../helpers/helpers";
import { useDispatch } from "react-redux";

const LeftSide = ({ projectsList, selectedProject, fillters, setFillters }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [burgerMenuIsOpen, setBurgerMenuIsOpen] = useState(false);
  return (
    <>
      <ul className="hidden border-b-2 border-primary-dark/30 row-span-2 row-start-1 col-span-4 col-start-1 xl:flex items-center justify-normal gap-4 list-none">
        {projectsList.map((project) => {
          return (
            <li
              key={project.id}
              className={`text-lg tracking-wider  ${
                selectedProject.id === project.id
                  ? "text-primary-bg-blue font-extrabold"
                  : "text-primary-bg-blue/30 hover:text-primary-bg-blue cursor-pointer transition-all duration-300 ease-linear font-semibold"
              } py-4 flex items-center justify-center gap-2`}
              onClick={() =>
                delayNavigation(
                  dispatch,
                  navigate,
                  `/projects/${project.name}/apartments`
                )
              }
            >
              <span>{project.label}</span>
              {selectedProject.id === project.id && (
                <TiArrowSortedDown className="text-2xl" />
              )}
            </li>
          );
        })}
      </ul>
      <FilterBurgerMenu
        fillters={fillters}
        setFillters={setFillters}
        selectedProject={selectedProject}
        burgerMenuIsOpen={burgerMenuIsOpen}
        setBurgerMenuIsOpen={setBurgerMenuIsOpen}
      />
      <div className="hidden row-start-3 col-span-full xl:col-span-4 xl:col-start-1 pt-8 pr-8 xl:flex flex-col gap-6 justify-start items-start">
        <img
          src={selectedProject.listImg}
          alt="K2 Invest Green Home"
          className="w-full h-full object-cover object-center"
        />
        <ul className=" text-primary-bg-blue w-full ">
          <li className="text-xl xl:text-4xl font-semibold tracking-wider border-b-2 border-b-primary-dark/30 border-opacity-30 pb-8">
            ფილტრები
          </li>
          <LeftSideFilterListItem
            label={"საძინებლის რაოდენობა"}
            fillters={fillters}
            setFillters={setFillters}
            selectedProject={selectedProject}
          />
          <LeftSideFilterListItem
            label={"სართული"}
            fillters={fillters}
            setFillters={setFillters}
            selectedProject={selectedProject}
          />
          <LeftSideFilterListItem
            label={"ფართის მიხედვით"}
            fillters={fillters}
            setFillters={setFillters}
            selectedProject={selectedProject}
          />
        </ul>
        <p
          className="hidden xl:block w-full relative group cursor-pointer text-xl font-bold tracking-wider text-primary-bg-blue border-b-2 border-b-primary-dark/30 border-opacity-30 py-8"
          onClick={() =>
            setFillters({
              floors: [],
              types: [],
              sizes: [],
            })
          }
        >
          ფილტრის გასუფთავება
          <span className="absolute bottom-0 left-0 w-0 h-[2px] bg-primary-bg-blue transition-all duration-500 group-hover:w-full"></span>
        </p>
        <Link
          className="hidden xl:block w-full relative group text-xl font-bold tracking-wider text-primary-bg-blue py-8"
          onClick={(event) => {
            delayNavigation(
              dispatch,
              navigate,
              `/projects/${selectedProject.name}/block`,
              event
            );
          }}
        >
          ვიზუალური სელექცია
          <span className="absolute bottom-0 left-0 w-0 h-[2px] bg-primary-bg-blue transition-all duration-500 group-hover:w-full"></span>
        </Link>
      </div>
    </>
  );
};

export default LeftSide;
